/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalMaterialRequire
 */
export interface SupplementalMaterialRequire {
    /**
     * 
     * @type {Date}
     * @memberof SupplementalMaterialRequire
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof SupplementalMaterialRequire
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof SupplementalMaterialRequire
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof SupplementalMaterialRequire
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalMaterialRequire
     */
    courseId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplementalMaterialRequire
     */
    studentType: SupplementalMaterialRequireStudentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SupplementalMaterialRequire
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplementalMaterialRequire
     */
    state: SupplementalMaterialRequireStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum SupplementalMaterialRequireStudentTypeEnum {
    Regular = 'regular',
    Research = 'research',
    Exchange = 'exchange'
}/**
* @export
* @enum {string}
*/
export enum SupplementalMaterialRequireStateEnum {
    Active = 'active',
    Hidden = 'hidden'
}

export function SupplementalMaterialRequireFromJSON(json: any): SupplementalMaterialRequire {
    return SupplementalMaterialRequireFromJSONTyped(json, false);
}

export function SupplementalMaterialRequireFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalMaterialRequire {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
        'courseId': json['courseId'],
        'studentType': json['studentType'],
        'required': json['required'],
        'state': json['state'],
    };
}

export function SupplementalMaterialRequireToJSON(value?: SupplementalMaterialRequire | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'courseId': value.courseId,
        'studentType': value.studentType,
        'required': value.required,
        'state': value.state,
    };
}


